.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  font-family: var(--font-display);
  letter-spacing: var(--letter-spacing-display);
  text-transform: uppercase;
  text-decoration: none;
  white-space: nowrap;
  border: var(--border-width-2) var(--border-style) var(--color-border);
  box-shadow: var(--shadow-pixel-md);
  cursor: pointer;
  user-select: none;
  transition: transform var(--transition-fast),
    box-shadow var(--transition-fast), background-color var(--transition-fast),
    color var(--transition-fast);
}

.btn:hover {
  transform: translate(-2px, -2px);
  box-shadow: 6px 6px 0 0 var(--color-shadow);
}

.btn:active {
  transform: translate(2px, 2px);
  box-shadow: 0 0 0 0 var(--color-shadow);
}

.btn:disabled,
.btn[aria-disabled="true"] {
  opacity: 0.55;
  cursor: not-allowed;
  transform: none;
  box-shadow: var(--shadow-pixel-sm);
}

/* ----- Sizes ----- */
.size_sm {
  padding: var(--space-2) var(--space-3);
  font-size: 0.625rem; /* 10px */
}
.size_md {
  padding: var(--space-3) var(--space-4);
  font-size: 0.75rem; /* 12px */
}
.size_lg {
  padding: var(--space-4) var(--space-5);
  font-size: 0.875rem; /* 14px */
}

/* ----- Variants ----- */
.variant_primary {
  background: var(--color-accent);
  color: var(--color-bg);
}
.variant_primary:hover,
.variant_primary:focus-visible {
  background: var(--color-accent-strong);
  color: var(--color-bg);
}

.variant_secondary {
  background: var(--color-bg-raised);
  color: var(--color-fg);
}
.variant_secondary:hover,
.variant_secondary:focus-visible {
  background: var(--color-magenta);
  color: var(--color-bg);
}

.variant_ghost {
  background: transparent;
  color: var(--color-fg);
  box-shadow: none;
  border-color: var(--color-fg-muted);
}
.variant_ghost:hover,
.variant_ghost:focus-visible {
  color: var(--color-accent);
  border-color: var(--color-accent);
  box-shadow: var(--shadow-pixel-sm);
}

.icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1em;
  height: 1em;
}

.label {
  display: inline-flex;
  align-items: center;
}
